/**
 * The small stat tiles.
 *
 * These render whether or not the number has arrived yet: a tile that only
 * appears once its data loads pushes everything below it down the page, and
 * on a slow connection that happens under the reader's cursor. Reserving the
 * space costs nothing and keeps the page still.
 */
import type { ReactNode } from "react";

interface MeterProps {
  label: string;
  /** Undefined while loading — the tile shows a placeholder at full height. */
  value?: ReactNode;
  /** Applied to the value only, so the placeholder stays neutral. */
  tone?: "warn";
}

export function Meter({ label, value, tone }: MeterProps) {
  const loading = value === undefined || value === null;

  return (
    <div className="meter">
      <div className="k">{label}</div>
      <div
        className={`v${tone && !loading ? ` meter-${tone}` : ""}`}
        aria-busy={loading || undefined}
      >
        {loading ? <span className="meter-skeleton" aria-hidden="true" /> : value}
      </div>
    </div>
  );
}

export function MeterRow({ children, className = "" }: { children: ReactNode; className?: string }) {
  return <div className={`meter-row ${className}`.trim()}>{children}</div>;
}
